import { isTest } from './helpers';

const injectTestEnvShims = () => {
  if (isTest) {
    if (!String.prototype.replaceall) {
      // This is a polyfill to support myString.replaceAll(). We use it in our code, jest (with some versions of node) don't support it.
      require('string.prototype.replaceall').shim();
    }
    if (!window.crypto || !window.crypto.getRandomValues) {
      Object.defineProperty(window, 'crypto', {
        value: {
          getRandomValues: arr => Array.from(Array(arr.length).keys())
        }
      });
    }
  }
};

export default injectTestEnvShims;
